import { createRef, useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import Offcanvas from 'react-bootstrap/Offcanvas';
import ReCAPTCHA from 'react-google-recaptcha';
import sha256 from 'sha256';
import SpinnerCuadrado from '../../modules/helpers/SpinnerCuadrado';
import { encodeBase64, encryptDecrypt } from '../../modules/helpers/validations';
//import { InputIconEyeActive, InputIconEyeInactive } from '../../assets/icons/Icons';
import ButtonClose from '../../modules/homeout/principal/components/modal/ButtonClose';
import SidebarActivarCuenta from './SidebarActivarCuenta';
import { getSession, postLogin } from '../../services/serviceVivetuseguro';
import * as CryptoJS from 'crypto-js';
import TagManager from 'react-gtm-module';
import SidebarPassword from './SidebarPassword';
import condicionesGenerales from "../../assets/docs/Condiciones Generales.pdf";

const SidebarLogin = ({ infoApi, show, setShow, setShowModalSuccess }) => {
  const handleClose = () => setShow(false);
  const [typeField, setTypeField] = useState(false);
  const [typeInput, setTypeInput] = useState('password');
  const [loading, setLoading] = useState(false);
  const [urlApi, setUrlApi] = useState('');
  const [codRecaptcha, setCodRecaptcha] = useState('');
  const [showModalActivar, setShowModalActivar] = useState(false);
  const [showModalPassword, setShowModalPassword] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [alerta, setAlerta] = useState(false);
  const [validarUser, setValidarUser] = useState(false);

  // RECAPTCHA
  const recaptchaRef = useRef();

  const [form, setForm] = useState({
    user: '',
    password: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleTypeField = (type) => {
    setTypeField(type);
    setTypeInput(type ? 'text' : 'password');
  };

  const getTyC = () => {
    const downloadLink = document.createElement('a');

    downloadLink.href = condicionesGenerales
    downloadLink.download = 'Condiciones Generales.pdf';
    downloadLink.click();
  };

  const handleSubmit = async () => {
    setAlerta(false);

    if (form.user.trim() !== '' && form.password.trim() !== '') {
      const token = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
      if (!token) {
        setMensaje('Captcha inválido, actualizar web');
        return;
      }

      //validar email
      const emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

      if (!emailRegex.test(form.user)) {
        return setValidarUser(true);
      }

      setValidarUser(false);

      let objUsuario = {
        usuario: form.user,
        password: encodeBase64(
          encryptDecrypt(sha256(form.password), token.substring(token.length - 10, token.length))
        ),
        sitioPassword: '9B9CB6631B27AA1DF47DB351B497004810015B09',
        sitioUsuario: 'CARDIF',
        deviceInfo: '',
        tokenCaptcha: token,
      };

      try {
        postLogin(objUsuario, urlApi).then((rpta) => {
          setAlerta(rpta.codigo === 1 ? true : false);
          setMensaje('El correo ingresado no existe.');

          if (rpta.codigo === 0) {
            localStorage.setItem(
              'token',
              CryptoJS.AES.encrypt(rpta.data.token, '8f6391895c404ab68eb7a8e42eb73587')
            );
            getSession(rpta.data.token, urlApi).then((data) => {
              let res = { data }.data;
              localStorage.setItem(
                'user',
                CryptoJS.AES.encrypt(JSON.stringify(res), '8f6391895c404ab68eb7a8e42eb73587')
              );

              setLoading(false);

              //Una vez validado que el usuario tenga el Seguro de Proteccion Financiera, se procede a ir al sitio de vivetuseguro pasando el token como parametro.
              let urlVivetuseguro = infoApi[0].urlFront + rpta.data.token;
              window.open(urlVivetuseguro, '_blank');

              setMensaje('');
            });
          } else if (rpta.codigo === 1) {
            // la clave es incorrecta
            // cuenta blowueada
            setAlerta(true);
            setMensaje(rpta.mensaje);
            setLoading(false);
          }
        });
      } catch (err) {
        TagManager.dataLayer({
          dataLayer: {
            event: 'login',
            category: 'login',
            action: 'Intento de logeo',
            label: 'Error',
          },
        });
        setMensaje('Hubo un problema en la autenticación.');
        setLoading(false);
      }
    } else {
      setAlerta(true);
      setMensaje('Para continuar debes completar todos los campos.');
    }
  };

  const openRegister = () => {
    handleClose();
    setShowModalActivar(true);
  };

  const openModalPassword = () => {
    handleClose();
    setShowModalPassword(true);
  };

  useEffect(() => {
    if (infoApi?.length < 1 || infoApi === undefined) return;
    infoApi?.forEach((element) => {
      setUrlApi(element.urlApi);
      setCodRecaptcha(element.cod_recaptcha);
    });
  }, [infoApi]);

  return (
    <>
      {loading && <SpinnerCuadrado />}

      <SidebarActivarCuenta
        infoApi={infoApi}
        show={showModalActivar}
        close={setShowModalActivar}
        showLogin={show}
        setShowLogin={setShow}
      />
      <SidebarPassword
        urlApi={urlApi}
        codRecaptcha={codRecaptcha}
        show={showModalPassword}
        setShow={setShowModalPassword}
        setShowModalSuccess={setShowModalSuccess}
      />

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Body>
          <div className=" d-none d-lg-block">
            <ButtonClose close={handleClose} />
          </div>
          <div className="d-lg-none  d-flex justify-content-end  " style={{ fontSize: '20px' }}>
            <div
              className="center_center borde_verde text-verde cursor rounded-5 mt-4 me-4  "
              onClick={handleClose}
              style={{ width: '30px', height: '30px' }}
            >
              x
            </div>
          </div>
          <div className="sticky__btn__sidebar_up d-none d-lg-block ">
            <button className="btn__sidebar_up " type="button" onClick={handleClose}>
              <b>
                INGRESA A TU
                <br />
                ECOSISTEMA AQUÍ
              </b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <i className="fa-solid fa-angle-down flecha__sticky__btn"></i>
            </button>
          </div>
          <div className="body__login">
            <h2 className="mb-5">Acceder a tu cuenta</h2>
            <p className="mt-5">
              Complete la información a <div className="d-block d-lg-none"></div>continuación para ingresar:
            </p>

            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
              }}
              className="form__modal"
            >
              <div className="row justify-content-center">
                {alerta && (
                  <div className="alert text-center bg-rojo w-100 text-white fs-4" role="alert">
                    {mensaje}
                  </div>
                )}
                <div className="col-12">
                  <input
                    type="text"
                    className={`form-control border-input ${alerta == true ? 'border-danger' : null}`}
                    id="user"
                    name="user"
                    placeholder="E-Mail"
                    autoComplete="off"
                    value={form.user}
                    onChange={handleChange}
                  />
                  {validarUser && <p className="text-danger  ">Ingrese un email válido</p>}
                </div>
                <div className="col-12 login__pass">
                  <input
                    maxLength={16}
                    type={typeInput}
                    className={`form-control border-input ${alerta == true ? 'border-danger' : null}`}
                    id="password"
                    name="password"
                    placeholder="Contraseña"
                    autoComplete="off"
                    value={form.password}
                    onChange={handleChange}
                  />
                  {typeField ? (
                    <i
                      onClick={() => handleTypeField(!typeField)}
                      className="fa-solid fa-eye pass__icon"
                    ></i>
                  ) : (
                    <i
                      onClick={() => handleTypeField(!typeField)}
                      className="fa-solid fa-eye-slash pass__icon"
                    ></i>
                  )}
                </div>

                <div className="col-12 recuperar__pass" onClick={openModalPassword}>
                  <p>Olvidé mi contraseña</p>
                </div>
                <div style={{ textAlign: 'center' }} className="col-12 mt-3 pt-5 mb-4">
                  <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={codRecaptcha} />
                  <div className="d-block d-lg-none">
                    <button className="btn__azul" style={{ padding: '1rem 7rem' }} onClick={handleSubmit}>
                      ENTRAR
                    </button>
                  </div>
                  <div className="d-none d-lg-block">
                    <button className="btn__azul" onClick={handleSubmit}>
                      ENTRAR
                    </button>
                  </div>
                </div>
              </div>

              <div className="linea-verde mx-5 d-none d-lg-block" style={{}}></div>
              <div className="div__activar-cuenta">
                <div className=" text-center text-black  h1 fw-bolder my-4">
                  <p>¿Aún no has </p>
                  <p>activado tu cuenta?</p>
                </div>
                <div style={{ textAlign: 'center' }} className="col-12 d-block d-lg-none">
                  <button
                    className="btn__azul "
                    style={{ padding: '1rem 5rem', fontSize: '14px' }}
                    onClick={openRegister}
                  >
                    ACTIVAR CUENTA
                  </button>
                </div>
                <div style={{ textAlign: 'center' }} className="col-12 d-none d-lg-block">
                  <button className="btn__azul" onClick={openRegister}>
                    ACTIVAR CUENTA
                  </button>
                </div>
                <div className="col-12 mt-3">
                  <p
                    className="modal__login__footer text-center mt-5 d-none d-lg-block text-decoration-underline"
                    onClick={getTyC}
                  >
                    Términos y Condiciones
                  </p>
                  <p className="modal__login__footer text-center mt-5 d-lg-none te" onClick={getTyC}>
                    Términos y Condiciones
                  </p>
                </div>
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SidebarLogin;
